// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 575px){\n.no-text[data-v-22d78f4b] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
